exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
exports.locals = {
  "logoImage": "_1r_FyRDZ"
};
exports.push([module.id, "._1r_FyRDZ{cursor:pointer;display:flex}", ""]);